import { addScriptDefault } from 'meta-pixel';

const fbq = addScriptDefault();

export const addToWishlist = (
  productNo: number,
  productName: string,
  salePrice: number,
  immediateDiscountAmt: number,
) => {
  fbq('track', 'AddToWishlist', {
    content_ids: [productNo],
    contents: [{ name: productName, quantity: 1 }],
    currency: 'KRW',
    value: salePrice - immediateDiscountAmt,
  });
};

export const initiateCheckout = (
  productNo: number[],
  contents: [{ name: string; quantity: number }],
  value: number,
) => {
  fbq('track', 'InitiateCheckout', {
    content_ids: productNo,
    contents: contents,
    currency: 'KRW',
    value: value,
  });
};

export const addPaymentInfo = (productNo: number[], contents: [{ name: string; quantity: number }], value: number) => {
  fbq('track', 'AddPaymentInfo', {
    content_ids: productNo,
    contents: contents,
    currency: 'KRW',
    value: value,
  });
};

export const addToCart = (
  productNo: number[],
  contents: [{ name: string; quantity: number }],
  content_type: string,
  value: number,
) => {
  fbq('track', 'AddToCart', {
    content_ids: productNo,
    contents: contents,
    content_type: content_type,
    currency: 'KRW',
    value: value,
  });
};

export const purchase = (productNo: number[], contents: [{ name: string; quantity: number }], value: number) => {
  fbq('track', 'Purchase', {
    content_ids: productNo,
    contents: contents,
    currency: 'KRW',
    value: value,
  });
};
